import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';

export const languageOptions = [
  { key: 'ar', value: 'ar', flag: 'ps', text: 'العربية', link: '/ar-lang' },
  { key: 'tr', value: 'tr', flag: 'tr', text: 'Türkçe', link: '/tr-lang' },
  { key: 'en', value: 'en', flag: 'us', text: 'English', link: '/en-lang' },
  { key: 'de', value: 'de', flag: 'de', text: 'Deutsch', link: '/de-lang' },
  { key: 'es', value: 'es', flag: 'es', text: 'Español', link: '/es-lang' },
  { key: 'fr', value: 'fr', flag: 'fr', text: 'Français', link: '/fr-lang' },
  { key: 'mx', value: 'mx', flag: 'mx', text: 'Español Mexicano', link: '/mx-lang' },
  { key: 'th', value: 'th', flag: 'th', text: 'ไทย', link: '/th-lang' },
  { key: 'ro', value: 'ro', flag: 'ro', text: 'Română', link: '/ro-lang' },
  { key: 'my', value: 'my', flag: 'my', text: 'Bahasa Melayu', link: '/my-lang' },
  { key: 'bg', value: 'bg', flag: 'bg', text: 'Български', link: '/bg-lang' },
  { key: 'id', value: 'id', flag: 'id', text: 'Bahasa Indonesia', link: '/id-lang' },
  { key: 'zh', value: 'zh', flag: 'cn', text: '中文', link: '/zh-lang' }
];

const LanguageSelector = ({
  onLanguageChange,
  currentLanguage
}) => {
  const handleChange = (e, { value }) => {
    const language = languageOptions.find(lang => lang.value === value);
    if (language && onLanguageChange) {
      onLanguageChange(language);
    }
  };

  return (
    <div className="language-selector" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <Dropdown
        icon={null}
        trigger={(
          <div
            className="language-trigger"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '2px',
              color: 'var(--primary)',
              padding: '0 6px',
              cursor: 'pointer',
              borderRadius: 'var(--radius)',
              height: '32px',
              width: '32px',
              border: '1px solid transparent',
              backgroundColor: 'transparent',
              transition: 'all 0.15s ease'
            }}
          >
            <Icon name="world" style={{ margin: 0, fontSize: '14px' }} />
          </div>
        )}
        floating
        options={languageOptions}
        onChange={handleChange}
        value={currentLanguage}
        pointing="top right"
        style={{ zIndex: 9999 }}
        className="language-dropdown left-aligned"
        onClick={(e) => e.stopPropagation()}
      />
      <style>{`
        .ui.dropdown.language-dropdown {
          display: flex !important;
          align-items: center !important;
          min-width: 0 !important; /* Fix 80px width issue */
          width: auto !important;
          margin: 0 !important;
        }
        .ui.dropdown.language-dropdown .menu {
          z-index: 9999 !important;
          background: var(--card) !important;
          border: 1px solid var(--border) !important;
          box-shadow: var(--shadow-lg) !important;
          border-radius: var(--radius) !important;
          min-width: 160px !important;
          left: auto !important;
          right: 0 !important;
        }
        .ui.dropdown.language-dropdown .menu > .item {
          color: var(--card-foreground) !important;
          padding: 8px 12px !important;
          font-size: 12px !important;
          border-top: none !important;
        }
        .ui.dropdown.language-dropdown .menu > .item:hover {
          background: var(--accent) !important;
          color: var(--accent-foreground) !important;
        }
        .ui.dropdown.language-dropdown .menu > .item.selected,
        .ui.dropdown.language-dropdown .menu > .item.active {
          background: var(--primary) !important;
          color: var(--primary-foreground) !important;
          font-weight: 600 !important;
        }
        .language-trigger:hover {
          background-color: var(--accent) !important;
          border-color: var(--primary) !important;
        }
      `}</style>
    </div>
  );
};

export default LanguageSelector;

